import { Box, BoxProps, HStack, Icon, Text } from "@chakra-ui/react";
import {
  EmrCalendar,
  EmrDownArrowFilled,
  EmrUpArrowFilled,
} from "@medstonetech/slate-icons";
import * as React from "react";

type OrderHeaderCardProps = {
  counter: number;
  title: string;
  icon: React.ReactNode;
  sortDesc?: boolean;
  showSortDesc?: boolean;
  onSortChange?: (value: boolean) => void;
  showScheduled?: boolean;
  onScheduledChange?: (value: boolean) => void;
  scheduled?: boolean;
} & Omit<BoxProps, "children">;

type DashboardOrderHeaderCardProps = Omit<
  OrderHeaderCardProps,
  "title" | "icon"
>;

function OrderHeaderCard(props: OrderHeaderCardProps) {
  const {
    counter,
    icon,
    title,
    color,
    sortDesc,
    showSortDesc,
    onSortChange,
    showScheduled,
    onScheduledChange,
    scheduled,
    ...restProps
  } = props;

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      padding="18px 20px 18px 28px"
      height="65px"
      width="100%"
      boxShadow="0px 4px 4px rgba(0, 0, 0, 0.1)"
      borderRadius="10px"
      {...restProps}
    >
      <HStack spacing="23px">
        {React.isValidElement(icon) &&
          React.cloneElement(
            icon as React.ReactElement<Record<string, unknown>>,
            {
              fontSize: "1.5rem",
              color: color ?? "white",
            }
          )}
        <Box fontSize="1.25rem" fontWeight="600" color={color ?? "white"}>
          {title}
        </Box>

        {showSortDesc && (
          <Box
            border="2px solid white"
            borderRadius="15px"
            padding="2px 12px"
            display="flex"
            alignItems="center"
            color="white"
            cursor="pointer"
            onClick={(e) => {
              e.stopPropagation();
              onSortChange?.(!sortDesc);
            }}
          >
            <Icon
              as={sortDesc ? EmrDownArrowFilled : EmrUpArrowFilled}
              fontSize="0.725rem"
              color="white"
              marginLeft="7px"
              marginRight="14px"
              marginTop={sortDesc ? "1px" : "0"}
            />
            <Text fontSize="1rem" fontWeight="500">
              {sortDesc ? "NEWEST" : "OLDEST"}
            </Text>
          </Box>
        )}
        {showScheduled && (
          <Box
            border="2px solid white"
            borderRadius="15px"
            padding="2px 12px"
            display="flex"
            alignItems="center"
            color={scheduled ? "orange" : "white"}
            cursor="pointer"
            backgroundColor={scheduled ? "white" : "transparent"}
            onClick={(e) => {
              e.stopPropagation();
              onScheduledChange?.(!scheduled);
            }}
          >
            <Icon
              as={EmrCalendar}
              fontSize="1rem"
              color={scheduled ? "orange" : "white"}
              marginLeft="7px"
              marginRight="14px"
              marginTop={scheduled ? "1px" : "0"}
            />
            <Text fontSize="1rem" fontWeight="500">
              Scheduled
            </Text>
          </Box>
        )}
      </HStack>
      <Box
        fontSize="1.875rem"
        fontWeight="600"
        color={color ?? "white"}
        lineHeight="1.375rem"
      >
        {counter}
      </Box>
    </Box>
  );
}

export { OrderHeaderCard };
export type { DashboardOrderHeaderCardProps, OrderHeaderCardProps };
